import { i18n } from './i18n.js';

import attribute from './models/attribute.js'
import parameter from './models/parameter.js'

import configuration from './models/configuration.js'

import APIClient from './services/APIClient.js'
import authentication from './services/auth.js'
import WholeSaler from './services/WholeSaler.js'
import mainElement from './models/mainElement.js'

import html2canvas from 'html2canvas'
import * as htmlToImage from 'html-to-image';
import { toPng, toJpeg, toBlob, toPixelData, toSvg } from 'html-to-image';

import './components/results/resultsHelper.js'
import resultsHelper from './components/results/resultsHelper.js';
import MultiLevel from './services/multiLevel.js';
import Projects from './services/projects.js';
import Configs from './services/configs.js';
export default class application {
    constructor() {
        this.AppComponent = null
        this.isSpinnerAlwaysVisible = false;

        this._language = new attribute();
        this._market = new attribute();
        this.auth = new authentication(this);

        this.env = 'prod'
        this.version = '3.0-rc1';
        this.webVersion = '1'
        this.API = new APIClient(this);
        this.userIsInsideMyConfigs = false;
        this.conditionsAccepted = false;
        this.udigitalAlertDismissed = false;

        this.currentConfiguration = new configuration();

        //images screen 4 gamma 66
        this.elementsImages = [];
        this.elementsImagesDireccionHorizontal = false;
        this.elementsImage_wall = false;
        this.elementsImage_ceiling = false;
        this.elementsImage_Floor = false;
        this.elementsImagesSize = '200px';

        this.configurators = [];
        this.atributs_seleccio_gamas_distr_cables_bandejas = [];
        this.dataP3 = new mainElement();
        this.dataGridElemAcabOpcVariantes = [];

        this.isDevelopmentMode = false;
        this.isSpinnerVisible = false;
        this.isSpinnerWhithoutBackgroundVisible = false;
        this.isProcessing = false;

        //modalComponent his value is assigned in the App.vue mounted lifecycle method
        this.modalComponent = null;
        this.toastWrapper = null

        this.router = null;
        this.showNavigationBar = true;

        this.commingToUnknownUrl = false;
        this.API_error = false;

        //ha de vindre del servidor cada cop que es fa la crida per cambiar de pantalla amb el idioma corresponent..?
        this.navigationbarElements = [
            { id: 0, order: 0, name: 'Idioma/mercado', activated: false, redirectToName: '0', urlImgDeact: 'images/navigationbar/Off.png', urlImgAct: 'images/navigationbar/On.png' },
            { id: 1, order: 1, name: 'Configuradores', activated: false, redirectToName: '1', urlImgDeact: 'images/navigationbar/Off.png', urlImgAct: 'images/navigationbar/On.png' },
            { id: 2, order: 2, name: 'Gamas', activated: false, redirectToName: '2', urlImgDeact: 'images/navigationbar/Off.png', urlImgAct: 'images/navigationbar/On.png' },
            { id: 3, order: 3, name: 'El. principal', activated: false, redirectToName: '3', urlImgDeact: 'images/navigationbar/Off.png', urlImgAct: 'images/navigationbar/On.png' },
            { id: 4, order: 4, name: 'Resultados', activated: false, redirectToName: '4', urlImgDeact: 'images/navigationbar/Off.png', urlImgAct: 'images/navigationbar/On.png' },
            { id: 'myConfigurations', name: 'mis Configuraciones', activated: true, redirectToName: 'myConfigurations', urlImgDeact: 'images/navigationbar/Off.png', urlImgAct: 'images/navigationbar/On.png' },
        ];

        this.checkIfDevelopmentMode();

        this.p3_zoomedImage = '';

        this.clickedGotoScreen0 = false;

        /** FireBase Analytics instance */
        /** @type firebase.analytics.Analytics */
        this.analytics = null;

        this.WholeSaler = new WholeSaler(this);


        // Helpers
        this.p1Helper = null;
        this.p2Helper = null;
        this.p3Helper = null;
        this.p4Helper = new resultsHelper(this);
        this.multiLevelHelper = new MultiLevel(this)
        this.projects = new Projects(this)
        this.configs = new Configs(this)

    }

    init() {
        var self = this
        Unex.log("Initializing configurator", "Configurator")

        this.languageParameter = new parameter(
            new attribute('idioma', 'Idioma:'),
            'dropdown'); //TODO: ha de vindre del servidor el titol del dropdown
        this.marketParameter = new parameter(
            new attribute('market', 'Mercado:'),
            'dropdown'); //TODO: ha de vindre del servidor el titol del dropdown

        // this.createNewConfiguration();
        this.loadSettingsLocalStorage();
        this.loadCurrentConfigurationFromSessionStorage();

        window.Unex.Authentication.on('logout', function () {
            // Reset settings
            self.loadSettingsLocalStorage()

            // Reset current configuration on user logout
            self.createNewConfiguration();
            self.currentConfiguration.stage = 0;
            self.navigateToStageAsync("0");
        });
    }

    initLanguageMarket(config = null) {
        let language = null
        let market = null
        let autoDetect = config == null ? false :
            config.autoDetectLanguage == null ? false : config.autoDetectLanguage;

        let languageUrl = this.getQueryString('lang')

        Unex.log("Initializing language and market", "Configurator")

        if (languageUrl != null) {
            Unex.log("Setting language from URL: " + languageUrl, "Configurator")
            language = languageUrl
        } else if (autoDetect) {
            language = navigator.language || navigator.userLanguage;
            Unex.log("Setting language from navigator: " + language, "Configurator")
        } else if (config.language != null) {
            language = config.language
            Unex.log("Setting language from config: " + language, "Configurator")
        }

        switch (language) {
            case 'es':
            case 'es-ES':
            case 'ca':
                language = 'es'
                market = "spain"; break;
            case 'es-cl':
                market = "chile"; break;
            case 'es-co':
                market = "colombia"; break;
            case 'fr':
            case 'fr-FR':
                language = 'fr'
                market = "france"; break;
            case 'it':
                market = "italia"; break;
            case 'es-mx':
                market = "mexico"; break;
            case 'pl':
                market = "polska"; break;
            case 'pt':
                market = "portugal"; break;
            case 'de':
                market = "deutschland"; break;
            case 'de-ch':
                language = 'de';
                market = "switzerland";
                break;
            case 'it-ch':
                language = 'it';
                market = "switzerland";
                break;
            case 'fr-ch':
                language = 'fr';
                market = "switzerland";
                break;
            case 'nl':
                market = "netherlands"; break;
            case 'en':
                market = "international"; break;
            case 'en-au':
                language = 'en';
                market = "australia";
                break;
            default:
                language = 'en'
                market = 'international'
                break;
        }

        this.loadLanguagesAndMarkets()

        if (language && market) {
            let oldLanguageId = this.language ? this.language.id : null;
            this.language = { "id": language }
            this.market = { "id": market }

            // let languageObject = null
            // let marketObject = null
            // this.languageParameter.values.forEach((value) => {
            //     if (value.id == language) {
            //         languageObject = value
            //     }
            //     value.childs.forEach((child) => {
            //         if (child.id == language) {
            //             languageObject = child
            //         }
            //     })
            // })
            // this.marketParameter.values.forEach((value) => {
            //     if (value.id == market) {
            //         marketObject = value
            //     }
            // })

            // this.language = languageObject
            // this.market = marketObject

            // this.loadConfigurators()
            if (oldLanguageId && oldLanguageId != language) {
                this.routerPush('1')
            }
            // if (this.currentConfiguration != null &&
            //     this.currentConfiguration.maxAvailableStage < 2) {
            //     this.routerPush('1')
            // }
        }
    }
    get language() { return this._language; }

    set language(newValue) {

        this._language = newValue;
        this.currentConfiguration.language = newValue;

        this.saveSettingToStorage("_language", newValue);

        // Analytics
        this.analytics.setUserProperties({
            language: newValue.id // can help you to define audiences
        });

        if (i18n.locale !== newValue.id) {
            i18n.locale = newValue.id;

            // català
            if (i18n.locale == 'es-ca') {
                i18n.fallbackLocale = 'es';
            }

            //chile
            if (i18n.locale == 'es-cl') {
                i18n.fallbackLocale = 'es';

            //colombia
            } else if (i18n.locale == 'es-co') {
                i18n.fallbackLocale = 'es';

                //mejico
            } else if (i18n.locale == 'es-mx') {
                i18n.fallbackLocale = 'es';

                //polonia
            } else if (i18n.locale == 'pl') {
                i18n.fallbackLocale = 'en';

                //russia
            } else if (i18n.locale == 'ru') {
                i18n.fallbackLocale = 'en';

                //holanda
            } else if (i18n.locale == 'nl') {
                i18n.fallbackLocale = 'en';

                //frances
            } else if (i18n.locale == 'fr') {
                i18n.fallbackLocale = 'en';

                //portugal
            } else if (i18n.locale == 'pt') {
                i18n.fallbackLocale = 'en';

            }
        }
    }

    get market() { return this._market; }
    set market(newValue) {

        this._market = newValue;
        this.currentConfiguration.market = newValue;

        this.saveSettingToStorage("_market", newValue);

        // Analytics
        this.analytics.setUserProperties({
            market: newValue.id // can help you to define audiences
        });

    }

    async loadLanguagesAndMarkets() {
        if (this.languageParameter.values.length > 0 &&
            this.marketParameter.values.length > 0) {
            return
        }
        //console.log('loadAvailableMarketsAndLanguages_and_updateCurrentConfig_ifPassed...');

        var self = this;

        self.showSpinner();
        self.marketParameter.values = await this.API.getAttributeValuesAsync('market')
        self.languageParameter.values = await this.API.getAttributeValuesAsync('idioma')

        self.hideSpinner();
    }
    loadAvailableMarketsAndLanguages_and_updateCurrentConfig_ifPassed(language = '', market = '') {

        //console.log('loadAvailableMarketsAndLanguages_and_updateCurrentConfig_ifPassed...');

        var self = this;

        self.showSpinner();

        //-------------------------------------
        //demana al servidor tots els mercats disponibles
        //que seran els que es mostraran en el dropdown
        //de la pantalla 0 languagemarket inicial
        //-------------------------------------
        self.API.getAttributeValues(
            'market',
            function (result) {
                //atualitza dropdown pantalla 0 market
                self.marketParameter.values = result;

                // if (market !== '') {
                //     //-------------------------------------------
                //     //si ja es sap el market actualitza el
                //     //currentconfiguration.market, envia servidor
                //     //currentconfiguration actualitzat i
                //     //actualitza el sessionstorage a través del asyncProcess
                //     //-------------------------------------------
                //     //console.warn('update market to ' + market);

                //     //app.market.id = to.query.market;
                //     app.market.id = market;
                //     app.currentConfiguration.market = app.marketParameter.values.filter(param => param.id === market)[0];
                //     app.saveSettingToLocalStorage('_market');
                //     app.asyncProcess(false, false);
                //     //-------------------------------------------
                // }
            },
            function (error) {

                console.warn('error self.API.getAttributeValue');
                //self.showModal({ 'message': error, 'title': 'Error' });

                let infoModal = {
                    modalToShow: "",
                    title: self.translate("popup_downloadBOM_error_titel"),
                    html_message: `<div class="alert alert-danger"> ${error} </div>`,
                    message: "",
                    showConfirmationButton: true,
                    showCancelButton: false,
                    textConfirmationButton: self.translate("default_text_acceptbutton"),
                    textCancelButton: self.translate("default_text_cancelbutton"),
                };

                self.showModal(infoModal);

            }
        );

        //-------------------------------------
        //demana al servidor tots els idiomes disponibles
        //que seran els que es mostraran en el dropdown
        //de la pantalla 0 languagemarket inicial
        //amb els seus childs es -> es-cl...
        //-------------------------------------
        self.API.getAttributeValues(
            'idioma',
            function (result) {
                //atualitza dropdown pantalla 0 language
                self.languageParameter.values = result;

                // VAYA BUG!

                // if (language !== '') {
                //     //-------------------------------------------
                //     //si ja es sap el idioma actualitza el
                //     //currentconfiguration.language, envia servidor
                //     //currentconfiguration actualitzat i
                //     //actualitza el sessionstorage a través del asyncProcess
                //     //-------------------------------------------
                //     //console.warn('update language to ' + language);

                //     app.language.id = language;
                //     app.currentConfiguration.language = app.languageParameter.values.filter(param => param.id === language)[0];
                //     app.saveSettingToLocalStorage('_language');
                //     app.asyncProcess(false, false);
                //     //-------------------------------------------
                // }
            },
            function (error) {
                console.warn('error self.API.getAttributeValue idioma');

                //------------------------------
                //FALTA AQUI POSAR MODAL NOU
                //------------------------------
                //self.showModal({ 'message': error, 'title': 'Error' })

                let infoModal = {
                    modalToShow: "",
                    title: self.translate("popup_getAttributeValues_language_error_titel"),
                    html_message: `<div class="alert alert-danger"> ${error} </div>`,
                    message: "",
                    showConfirmationButton: true,
                    showCancelButton: false,
                    textConfirmationButton: self.translate("default_text_acceptbutton"),
                    textCancelButton: self.translate("default_text_cancelbutton"),
                };

                self.showModal(infoModal);

                //------------------------------
            })

        // app.saveSettingToLocalStorage("_market");
        // app.saveSettingToLocalStorage("_language");

        self.hideSpinner();
    }

    loadConfigurators() {

        //console.log('loadConfigurators...');

        var self = this;

        self.showSpinner();

        self.API.getAttributeValues('configurador',
            function (result) {
                //console.log('loadConfigurators getAttributeValues result: ', result);
                self.configurators = result;
            },
            function (error) {
                console.warn('UNEX: Error connecting server for configurators: ', error)
            }
        );

        self.hideSpinner();
    }

    downloadBOM(format, configurationId) {

        //console.log('downloadBOM - application');
        //TODO: sha de mirar
        var self = this;

        self.showSpinner();

        self.API.downloadBOM(
            format,
            configurationId,

            //callback_OK
            (response) => {
                self.hideSpinner();

                // Analytics
                self.trackEvent('5_download_bom');
            },

            //callback_KO
            (error) => {
                self.hideSpinner();

                let infoModal = {
                    modalToShow: "",
                    title: self.translate("popup_downloadBOM_error_titel"),
                    html_message: `<div class="alert alert-danger"> ${error} </div>`,
                    message: "",
                    showConfirmationButton: true,
                    showCancelButton: false,
                    textConfirmationButton: self.translate("default_text_acceptbutton"),
                    textCancelButton: self.translate("default_text_cancelbutton"),
                };

                //ES6 destructuring object resolved from promise:
                self.showModal(infoModal);
            },

            //callback_connexion_KO
            (connex_error) => {
                self.hideSpinner();

                let infoModal = {
                    modalToShow: "",
                    title: self.translate("popup_downloadBOM_error_titel"),
                    html_message: `<div class="alert alert-danger"> ${connex_error} </div>`,
                    message: "",
                    showConfirmationButton: true,
                    showCancelButton: false,
                    textConfirmationButton: self.translate("default_text_acceptbutton"),
                    textCancelButton: self.translate("default_text_cancelbutton"),
                };

                //ES6 destructuring object resolved from promise:
                self.showModal(infoModal);
            }

        )

    }

    async saveModifiedKit(kit) {

        //console.log('saveModifiedKit - application');

        //TODO: sha de mirar
        var self = this;

        return await self.API.saveModifiedKit(

            kit,

            //callback_KO
            (error) => {
                let infoModal = {
                    modalToShow: "",
                    title: self.translate("popup_saveModifiedKit_error_titel"),
                    html_message: `<div class="alert alert-danger"> ${error} </div>`,
                    message: "",
                    showConfirmationButton: true,
                    showCancelButton: false,
                    textConfirmationButton: self.translate("default_text_acceptbutton"),
                    textCancelButton: self.translate("default_text_cancelbutton"),
                };

                //ES6 destructuring object resolved from promise:
                self.showModal(infoModal);
            }

        )

    }

    checkIfDevelopmentMode() {
        //    if (webpackHotUpdate) {this.isDevelopmentMode = true;}
    }

    showSpinner() { this.isSpinnerVisible = true; }

    hideSpinner() { this.isSpinnerVisible = false; }

    /**
     * Show a modal with the terms and conditions
     *
     * @returns Promise<boolean>
     */
    async acceptConditions(force = false) {
        let accepted = false

        if (!force) accepted = await Unex.Privacy.showTools();

        if (force == true || accepted == true) {
            Unex.log("Use Conditions accepted", "Configurator")
            this.conditionsAccepted = true;
            this.saveSettingToStorage('conditionsAccepted', true);
            return true
        }

        return false
    }

    dismissAlertUDigital() {
        this.udigitalAlertDismissed = true
        this.saveSettingToStorage('udigitalAlertDismissed', true);
    }
    showModal(infoModal) {
        let self = this;
        this.isModalVisible = true;

        // modal Component not mounted, defaults to CONFIRMED
        if (self.modalComponent == null) {
            return {
                // userAction: "modal_confirmed"
            }
        };

        return new Promise(function (resolve, reject) {
            if (self.modalComponent !== undefined) {
                self.modalComponent.showModal(infoModal).then(
                    result => {
                        resolve(result);
                    }
                )
            }
        });
    }

    getQueryString(param) {
        let params = this.getQueryStringParams()

        return params.get(param);

        if (params[param] != 'undefined') {
            return params[param]
        }

        return null
    }
    getQueryStringParams(query = null) {
        let url = query == null ? window.location.href : query
        const url1 = new URL(url);
        const params = new URLSearchParams(url1.search);
        return params
        return url
            ? (/^[?#]/.test(url) ? url.slice(1) : url)
                .split('&')
                .reduce((params, param) => {
                    let [key, value] = param.split('=');
                    params[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : '';
                    return params;
                }, {}
                )
            : {}
    }

    /**
     * Saves a setting into local storage
     * @param {*} settingName
     */
    saveSettingToStorage(settingName, settingValue) {
        if( settingValue == null){
            sessionStorage.removeItem(
                settingName
            )
        }else{
            sessionStorage.setItem(
                settingName,
                JSON.stringify(settingValue)
            );
        }
    }
    /**
     * Gets a settings from local storage
     * @param {*} settingName
     * @returns
     */
    getSettingFromStorage(settingName) {
        if (sessionStorage.getItem(settingName)) {
            return sessionStorage.getItem(settingName)
        }
        return null
    }
    checkIfSettingsAreOk() {
        Unex.log("Navigate to stage 0 if necessary", "Configurator")

        try {
            if (!this.language || !this.language.id || !this.market || !this.market.id) {
                this.createNewConfiguration();
                this.currentConfiguration.stage = 0;
                // this.loadAvailableMarketsAndLanguages_and_updateCurrentConfig_ifPassed();
                this.navigateToStageAsync("0");
                return false;
            }

        } catch (error) {

            console.error('no localStorage.getItem(_language) or no localStorage.getItem(_market)');
            this.createNewConfiguration();
            this.currentConfiguration.stage = 0;
            this.loadLanguagesAndMarkets();
            // this.loadAvailableMarketsAndLanguages_and_updateCurrentConfig_ifPassed();
            this.navigateToStageAsync("0");
            return false;

        }

        return true;
    }

    /**
     * Tries to load language and market from localstorage
     */
    loadSettingsLocalStorage() {
        Unex.log("Load settings from local storage", "Configurator")

        let _lang = JSON.parse(
            this.getSettingFromStorage('_language')
        );
        if (_lang && _lang.id) {
            Unex.log("Language found in storage!", "Configurator")
            this.language = _lang
        }

        let _market = JSON.parse(
            this.getSettingFromStorage('_market'));
        if (_market && _market.id) {
            Unex.log("Market found in storage!", "Configurator")
            this.market = _market
        }

        let conditionsAccepted = this.getSettingFromStorage('conditionsAccepted')
        if (conditionsAccepted) {
            this.conditionsAccepted = true;
        }

        let udigitalAlertDismissed = this.getSettingFromStorage('udigitalAlertDismissed')
        if (udigitalAlertDismissed) {
            this.udigitalAlertDismissed = true
        }
    }
    // deleteSettingsFromLocalStorage() {
    //     Unex.log("Delete settings from storage!", "Configurator")

    //     if (localStorage.getItem('_language')) {
    //         localStorage.removeItem('_language')
    //     }
    //     if (localStorage.getItem('_market')) {
    //         localStorage.removeItem('_market')
    //     }
    //     this._language = new attribute();
    //     this._market = new attribute();
    // }

    //sessionstorage
    saveCurrentConfigurationToSessionStorage() {
        this.saveSettingToStorage(
            'currentConfiguration',
            this.currentConfiguration
        );
    }

    loadCurrentConfigurationFromSessionStorage() {
        Unex.log("Load configuration from storage", "Configurator")

        if (this.getSettingFromStorage("currentConfiguration")) {
            Unex.log("Configuration found!", "Configurator")
            this.currentConfiguration = JSON.parse(
                this.getSettingFromStorage('currentConfiguration')
            );
        }

        if (typeof this.currentConfiguration !== 'object'
            || this.currentConfiguration == null) {
            Unex.log("Configuration reset!", "Configurator")
            this.createNewConfiguration();
        }

    }

    // deleteCurrentConfigurationFromSessionStorage() {
    //     let currentConfiguration, lang, mark;

    //     currentConfiguration = sessionStorage.getItem('currentConfiguration');

    //     if (currentConfiguration) {
    //         lang =  currentConfiguration.language;
    //         mark =  currentConfiguration.market;
    //         sessionStorage.removeItem('currentConfiguration');
    //     }
    // }

    async createNewConfiguration() {

        Unex.log("Creating new configuration", "Configurator")

        if (this.language && this.language.id &&
            this.market && this.market.id) {
            this.currentConfiguration = new configuration();

            this.currentConfiguration.language = this.language;
            this.currentConfiguration.market = this.market;
            this.currentConfiguration.maxAvailableStage = 1;
        }
        else {
            this.currentConfiguration = new configuration();
            this.currentConfiguration.maxAvailableStage = 0;
        }
        this.saveCurrentConfigurationToSessionStorage();
    }


    async beforeEnterStage(newStage, next, to) {
        Unex.log("BeforeEnterStage: trying to enter /" + newStage, "Configurator")

        //Cancel navigation
        next(false);

        //-----------------------------------------------------------------------------------------------
        //si produit error servidor i mostrat missatge avisant usari no mostris més missatges de avís
        //-----------------------------------------------------------------------------------------------
        if (this.API_error) {
            Unex.log("BeforeEnterStage: api-error", "Configurator")

            this.API_error = false;
            next(true);
            return true;
        }

        //--------------------------------------------------------------------------------------
        //si es vol anar a pag seleccio idioma i mercat o no hi és al localstorage
        //--------------------------------------------------------------------------------------
        if (newStage === 'language' || newStage === 0) {
            Unex.log("BeforeEnterStage: reset", "Configurator")

            this.createNewConfiguration();

            //console.log('newStage === language || newStage === 0');
            if (this.language == null || this.market == null) {
                next(true);
                return true;
            }
            this.currentConfiguration.maxAvailableStage = 1
            next(true);
            this.routerPush('1')
            return true;
            // this.currentConfiguration.stage = 0;


        } else if (newStage > 0) {
            Unex.log("BeforeEnterStage: >0", "Configurator")

            // WholeSaler/Authentication
            if (this.WholeSaler.isWholeSaler == true &&
                this.WholeSaler.isAuthorized == false) {

                await this.routerPushAsync('mustLogin');

                next(true);
                return true;
            }

            // Conditions accepted
            if (newStage > 1 && this.conditionsAccepted == false) {
                let accepted = await this.acceptConditions()

                if (accepted == false) {
                    next(false)
                    return false;
                }

                // let result = await this.asyncModal(
                //     this.translate('s1_use_conditions_popup'),
                //     false,
                //     this.translate('cancel_text')
                // );
                // next(false);

                // // TODO: bug

                // if (result == true) {
                //     this.acceptConditions();
                // } else {
                // }
            }

            // Is language and market ok?
            if (this.checkIfSettingsAreOk()) {

                //--------------------------------
                //valida configuracio actual
                //--------------------------------
                //OJO, aqui posat a true que mostri el spinner, si es mostra dos cops pot ser que aquesta sigui la causa, sino posar
                //await this.asyncProcess(false, true);

                //consulta currentconfiguration.maxAvailablestage
                let maxAvailableStage = this.maxAvailableStage();

                if (newStage < maxAvailableStage) {

                    //-----------------------------------------------------------
                    //descomentar nomes si visible buto menu idioma/mercat del fil d'Ariadna
                    //-----------------------------------------------------------
                    //if (this.clickedGotoScreen0) this.clickedGotoScreen0 = false;
                    //-----------------------------------------------------------

                    // if going backwards then ask user:
                    if (! await this.askForLostChanges()) {
                        // User canceled navigation => exit
                        next(false);
                        return false;
                    }

                    // Netejar configuració o resetejar
                    if (newStage == 1) {
                        this.createNewConfiguration();
                    } else {
                        this.currentConfiguration.stage = newStage;
                        await this.asyncProcess(true, false);
                    }

                    next(true);
                    return true;

                } else if (newStage === maxAvailableStage) {
                    //----------------------------------------
                    // Stage forward
                    // newStage is Ok -> pantalla ha estat validad
                    //----------------------------------------
                    this.trackGoal(newStage);
                    this.currentConfiguration.stage = maxAvailableStage;

                    if (newStage === 4) {
                        //no facis comprobacio de validesa de configuracio perque el nou estat encara ha de ser omplert per usuari
                        //----------------------------------------------------
                        //TODO: NOMES PER AJUDAR A COSTRUIR ELS KITS
                        //----------------------------------------------------
                        //BORRAR
                        await this.asyncProcess(true, true);
                        //UN COP BORRAT DESCOMENTAR LINEA INFERIOR
                        //await this.asyncProcess(true, false);
                        //----------------------------------------------------

                    } else if (newStage == 1) {
                        this.createNewConfiguration();
                    } else {
                        //no comprobis validesa de configuracio perque el nou estat encara ha de ser omplert per usuari,
                        //la validacio ja sha realitzat abans de assignar el this.currentConfiguration.stage al maxAvailableStage
                        await this.asyncProcess(true, false, this.currentConfiguration.stage === 3 ? true : false);
                    }

                    next(true);
                    return true;
                }else{
                    // Netejar configuració o resetejar
                    this.createNewConfiguration();

                    next(false);
                    this.routerPush('1')
                }
            }
        }
    }

    maxAvailableStage() {

        let maxAvailableStage = this.currentConfiguration.maxAvailableStage;

        // If there is no maxAvailableStage, then current stage is the max one
        if (!maxAvailableStage) {
            console.warn('no hi ha maxAvailableStage');
            return 0;
        }

        return maxAvailableStage;
    }

    canNavigateToStage(newStage) {
        let maxAvailableStage = this.maxAvailableStage();
        if (maxAvailableStage) {
            // User can always go back in stage
            if (newStage < maxAvailableStage) return true;
            if (newStage == maxAvailableStage) return true;

            return false;

        } else {
            Unex.log("No maxAvailableStage", "Configurator")
            this.createNewConfiguration();
            this.asyncProcess();
        }

    }

    async navigateToStageAsync(newStage, next) {
        await this.routerPush(newStage);

        if (this.currentConfiguration.stage >= newStage) {
            // Success
            return true;
        } else {
            // Failed
            return false;
        }
    }

    async askForLostChanges() {

        // Create the modal
        let infoModal = {
            modalToShow: "warnPageLeaveModal",
            title: this.translate("popup_warn_changes_will_be_lost_titel"),
            message: this.translate("popup_warn_changes_will_be_lost_message"),
            html_message: "",
            showConfirmationButton: true,
            showCancelButton: true,
            textConfirmationButton: this.translate("default_text_acceptbutton"),
            textCancelButton: this.translate("default_text_cancelbutton")
        };

        let result = await this.showModal(infoModal);
        if (result.userAction === "modal_rejected") {
            return false;

            //do nothing
        } else if (result.userAction === "modal_confirmed") {
            return true;
        }
    }

    async asyncModal(text, show_cancelButton = false, textConfirmationButton = null) {

        // Create the modal
        let infoModal = {
            modalToShow: "warnPageLeaveModal",
            title: this.translate("popup_warn_changes_will_be_lost_titel"),
            message: text,
            html_message: "",
            showConfirmationButton: true,
            showCancelButton: show_cancelButton,
            textConfirmationButton: textConfirmationButton ?
                textConfirmationButton :
                this.translate("default_text_acceptbutton"),
            textCancelButton: this.translate("default_text_cancelbutton")
        };

        let result = await this.showModal(infoModal);

        if (result.userAction === "modal_rejected") {
            return false;

            //do nothing
        } else if (result.userAction === "modal_confirmed") {
            return true;
        }
    }

    async navigateToNextStage() {

        await this.asyncProcess(false, true);

        if (!this.currentConfiguration.validation.valid) {
            await this.showConfigurationErrors();
            return false
        } else {

            return await this.navigateToStageAsync(this.maxAvailableStage());
        }
    }
    async navigateToPreviousStage() {
        let stage = parseInt(this.currentConfiguration.stage);

        await this.navigateToStageAsync(stage - 1);
    }

    showMyConfigs() {
        var self = this;
        self.routerPush('myConfigs');
    }
    navigateToStage(newStage) {
        throw ("Not valid!");

        var self = this;

        self.checkStage(
            newStage,
            //en cas que el servidor no retorni error navega a la nova ruta volguda newStage, alla ja es tornara a comparar si compleix
            () => {
                self.routerPush(newStage);
            },
            //en cas que el servidor retorni error no facis res
            () => {

                var errorMessage = '';

                this.currentConfiguration.validation.errors.forEach(element => {

                    if (element.includes('configuration.validate.noValueForParameter')) {

                        errorMessage += '<div class="alert alert-danger">' +
                            self.translate("app_checkstate_empty_field_error_part_1") + element.split(' ')[1] +
                            self.translate("app_checkstate_empty_field_error_part_2") + ' </div>';

                    } else {
                        errorMessage += '<div class="alert alert-danger">' + element + '</div>';
                    }

                });

                let infoModal = {
                    modalToShow: "",
                    title: self.translate('popup_checkStage_error_titel'),
                    html_message: errorMessage,
                    message: "",
                    showConfirmationButton: true,
                    showCancelButton: false,
                    textConfirmationButton: self.translate('default_text_acceptbutton'),
                    textCancelButton: self.translate('default_text_cancelbutton')
                };

                //ES6 destructuring object resolved from promise:
                self.showModal(infoModal)
                    .then(({ userAction, paramResult }) => {
                        if (userAction === "modal_rejected") {
                            //do nothing
                        } else if (userAction === "modal_confirmed") {
                            //self.routerPush(newStage);
                        }
                    });

            },

            //es passa false a param b_checkIsCalledBeforeRouteEntersNewStage pq no volem que assigni a stage un numero mes
            false
        );
    }

    getCurrentConfiguration() {

        let config;

        Object.values(this.currentConfiguration.familyParameters).
            forEach((param) => {
                config = param.attribute.name + ': ' + param.valueString + '\n';
            });

        Object.values(this.currentConfiguration.commonMainElementParameters).
            forEach((param) => {
                config += param.attribute.name + ': ' + param.valueString + '\n';
            });

        return config;

    }

    async showConfigurationErrors() {
        // A Pantalla 4, no mostrar modal
        if (this.currentConfiguration.stage === 4) return;

        Unex.warn("Showing configuration errors", "Configurator")

        let gama = this.currentConfiguration.familyParameters.gama ? this.currentConfiguration.familyParameters.gama.value.id : '0';
        var errorMessage = '';
        var self = this;

        let fieldWithoutValueContempled;

        this.currentConfiguration.validation.errors
            .forEach(element => {

                if (element && element.message.includes('noValueForParameter')) {

                    if (!fieldWithoutValueContempled) {

                        errorMessage += '<div class="alert alert-danger">' + self.translate("app_checkstate_empty_field");
                        fieldWithoutValueContempled = true;

                        //texte a enviar en el mail en funcio del idioma

                        let body_noValueForParameter = "";
                        body_noValueForParameter += self.translate("error_blank_field_user_comment_mail_technical_service") + '\n\n';
                        body_noValueForParameter += self.translate("error_blank_field_telf_mail_technical_service") + '\n\n';
                        body_noValueForParameter += self.translate("error_blank_field_configuracion_mail_technical_service") + '\n';
                        body_noValueForParameter += self.getCurrentConfiguration();

                        if (app.auth.email) { body_noValueForParameter += '\n \n' + app.auth.email; }

                        errorMessage += '<div class="mt-1"><a class="btn btn-danger" style="color: white !important" id="asistencia_mailto_blank_field" href="mailto:asistencia.tecnica@unex.net?subject=' +
                            self.translate("error_blank_field_subject_mail_technical_service") + '&body=' +
                            encodeURIComponent(body_noValueForParameter) + '">' +
                            self.translate("text_send_mail_empty_field") + '</a>' +
                            ' </div></div>';
                    }

                } else if (element && element.message.includes('mustSelectLanguage')) {

                    errorMessage += '<div class="alert alert-danger">' + self.translate("s0_error_mustSelectLanguage") + '</div>';

                } else if (element && element.message.includes('mustSelectMarket')) {

                    errorMessage += '<div class="alert alert-danger">' + self.translate("s0_error_mustSelectMarket") + '</div>';

                    //element.parameter_related == self.keyElementShownInPopup
                } else if (element &&
                    element.message.includes('tooManyMechanisms')
                ) {

                    errorMessage += '<div class="alert alert-danger">' +
                        self.translate("s4_error_tooManyMechanisms") +
                        element.message.split('/').pop() +
                        '</div>';

                } else if (element && element.message.includes('notEnoughMechanisms')) {
                    //do nothing
                    //errorMessage += '<div class="alert alert-danger">' + self.translate("s0_error_mustSelectMarket") + '</div>';
                    errorMessage += '<div class="alert alert-danger">' + element.message + '</div>';

                } else if (element && element.message.includes('configuration.calculateSupports.unsupportedStructure')) {

                    if (app.currentConfiguration.metadata &&
                        app.currentConfiguration.metadata.distance_supports_proposed &&
                        app.currentConfiguration.metadata.distance_supports_proposed == 'n/a') {
                        // No valid support (any distance)
                        errorMessage += '<div class="alert alert-danger">' +
                            '<div>' + self.translate("app_checkstate_no_valid_supports_invalid") + ' </div>';
                    } else {
                        // no valid support, but distance
                        errorMessage += '<div class="alert alert-danger">' +
                            '<div>' + self.translate("app_checkstate_distance_between_supports_invalid") + ' </div>';
                    }
                    let body = "";

                    body += self.translate("error_structure_user_comment_mail_technical_service") + '\n\n';
                    body += self.translate("error_structure_telf_mail_technical_service") + '\n\n';
                    body += self.translate("error_structure_configuracion_mail_technical_service") + '\n';
                    body += self.getCurrentConfiguration();

                    if (gama === '66') {

                        Object.entries(this.currentConfiguration.mainElementParameters).
                            forEach(([keyParam, valueParam]) => {

                                if (this.market.id === 'spain') {
                                    body += '\nBandeja: Fila ' + keyParam.split('-')[0] + ' Columna ' + keyParam.split('-')[1] + '\n';
                                    body += 'Dimensiones: ' + valueParam.dimensiones.valueString + '\n';
                                    body += 'Base: ' + valueParam.opcion_base.valueString + '\n';
                                    body += 'Compartimentos: ' + valueParam.opcion_compartimento.valueString + '\n';
                                    body += 'Tapa: ' + valueParam.opcion_tapa.valueString + '\n';

                                } else if (this.market.id === 'italy') {
                                    body += '\nPasserelle: Fila ' + keyParam.split('-')[0] + ' Colonna ' + keyParam.split('-')[1] + '\n';
                                    body += 'Dimensioni: ' + valueParam.dimensiones.valueString + '\n';
                                    body += 'Base: ' + valueParam.opcion_base.valueString + '\n';
                                    body += 'Nº de compartimenti: ' + valueParam.opcion_compartimento.valueString + '\n';
                                    body += 'Coperchio: ' + valueParam.opcion_tapa.valueString + '\n';

                                } else if (this.market.id === 'holland') {
                                    body += '\nKabelgoot: Rijen ' + keyParam.split('-')[0] + ' Columna ' + keyParam.split('-')[1] + '\n';
                                    body += 'Afmetingen: ' + valueParam.dimensiones.valueString + '\n';
                                    body += 'Bodem: ' + valueParam.opcion_base.valueString + '\n';
                                    body += 'Aantal compartimenten: ' + valueParam.opcion_compartimento.valueString + '\n';
                                    body += 'Deksel: ' + valueParam.opcion_tapa.valueString + '\n';

                                } else if (this.market.id === 'france') {
                                    body += '\nChemins de câble: Ligne ' + keyParam.split('-')[0] + ' Colonne ' + keyParam.split('-')[1] + '\n';
                                    body += 'Dimensions: ' + valueParam.dimensiones.valueString + '\n';
                                    body += 'Base: ' + valueParam.opcion_base.valueString + '\n';
                                    body += 'Nombre de compartiments: ' + valueParam.opcion_compartimento.valueString + '\n';
                                    body += 'Couvercle: ' + valueParam.opcion_tapa.valueString + '\n';

                                } else if (this.market.id === 'germany') {
                                    body += '\nKabelrinne: Zeile ' + keyParam.split('-')[0] + ' Spalte ' + keyParam.split('-')[1] + '\n';
                                    body += 'Abmessungen: ' + valueParam.dimensiones.valueString + '\n';
                                    body += 'Ausführung: ' + valueParam.opcion_base.valueString + '\n';
                                    body += 'Trennung: ' + valueParam.opcion_compartimento.valueString + '\n';
                                    body += 'Abdeckung: ' + valueParam.opcion_tapa.valueString + '\n';

                                }
                            });

                    } else if (gama === '67') {

                        Object.entries(this.currentConfiguration.mainElementParameters).
                            forEach(([keyParam, valueParam]) => {

                                console.log('param mainElementParameters 67: ', valueParam);

                                if (this.market.id === 'spain') {
                                    body += '\nPosición Bandeja: Fila ' + keyParam.split('-')[0] + ' Columna:' + keyParam.split('-')[1] + '\n';
                                    body += 'Dimensiones: ' + valueParam.dimensiones.valueString + '\n';
                                    body += 'Tapa: ' + valueParam.opcion_tapa.valueString + '\n';

                                } else if (this.market.id === 'italy') {
                                    body += '\nPosizione passerelle: Fila ' + keyParam.split('-')[0] + ' Colonna:' + keyParam.split('-')[1] + '\n';
                                    body += 'Dimensioni: ' + valueParam.dimensiones.valueString + '\n';
                                    body += 'Coperchio: ' + valueParam.opcion_tapa.valueString + '\n';

                                } else if (this.market.id === 'holland') {
                                    body += '\nPositie Kabelgoot: Rijen ' + keyParam.split('-')[0] + ' Columna:' + keyParam.split('-')[1] + '\n';
                                    body += 'Afmetingen: ' + valueParam.dimensiones.valueString + '\n';
                                    body += 'Deksel: ' + valueParam.opcion_tapa.valueString + '\n';

                                } else if (this.market.id === 'francia') {
                                    body += '\Chemins de câble: Ligne ' + keyParam.split('-')[0] + ' Colonne:' + keyParam.split('-')[1] + '\n';
                                    body += 'Dimensions: ' + valueParam.dimensiones.valueString + '\n';
                                    body += 'Couvercle: ' + valueParam.opcion_tapa.valueString + '\n';

                                } else if (this.market.id === 'germany') {
                                    body += '\nKabelrinne: Zeile ' + keyParam.split('-')[0] + ' Spalte ' + keyParam.split('-')[1] + '\n';
                                    body += 'Abmessungen: ' + valueParam.dimensiones.valueString + '\n';
                                    body += 'Ausführung: ' + valueParam.opcion_base.valueString + '\n';
                                    body += 'Trennung: ' + valueParam.opcion_compartimento.valueString + '\n';
                                    body += 'Abdeckung: ' + valueParam.opcion_tapa.valueString + '\n';

                                }
                            });
                    }

                    if (app.auth.email) { body += '\n \n' + app.auth.email; }

                    errorMessage += '<div class="mt-1"><a class="btn btn-danger" id="asistencia_mailto" href="mailto:asistencia.tecnica@unex.net?subject=' + self.translate("error_structure_subject_mail_technical_service") + '&body=' + encodeURIComponent(body) + '">' + self.translate("text_send_mail_error_config") + '</a>' +
                        ' </div></div>';


                } else {
                    errorMessage += '<div class="alert alert-danger">' + element.message + '</div>';
                }
            });

        let infoModal = {
            modalToShow: "",
            title: self.translate('popup_checkStage_error_titel'),
            html_message: errorMessage,
            message: "",
            showConfirmationButton: true,
            showCancelButton: false,
            textConfirmationButton: self.translate('text_continue_with_configuration'),
            textCancelButton: ""
        };

        await self.showModal(infoModal);

    }

    hasConfigurationErrors() {
        return this.currentConfiguration.validation.errors.length > 0
            ? true
            : false
    }
    getConfigurationErrors() {
        // Unex.warn("Getting configuration errors", "Configurator")

        let gama = this.currentConfiguration.familyParameters.gama ? this.currentConfiguration.familyParameters.gama.value.id : '0';
        var errorMessage = '';
        var self = this;

        let fieldWithoutValueContempled;

        let errors = []

        this.currentConfiguration.validation.errors
            .forEach(element => {

                if (element && element.message.includes('noValueForParameter')) {

                    if (!fieldWithoutValueContempled) {
                        errors.push(
                            self.translate("app_checkstate_empty_field")
                        )
                        fieldWithoutValueContempled = true;
                    }

                } else if (element && element.message.includes('mustSelectLanguage')) {
                    errors.push(
                        self.translate("s0_error_mustSelectLanguage")
                    )

                } else if (element && element.message.includes('mustSelectMarket')) {
                    errors.push(
                        self.translate("s0_error_mustSelectMarket")
                    )

                    // } else if (element &&
                    //     element.message.includes('tooManyMechanisms')
                    // ) {
                    //     errors.push(
                    //         self.translate("s4_error_tooManyMechanisms") +
                    //         element.message.split('/').pop()
                    //     )

                } else if (
                    element && (
                        element.message.includes('notEnoughMechanisms') ||
                        element.message.includes('tooManyMechanisms')
                    )
                ) {
                    errors.push(
                        element.message
                    );

                } else if (element && element.message.includes('configuration.calculateSupports.unsupportedStructure')) {

                    if (app.currentConfiguration.metadata &&
                        app.currentConfiguration.metadata.distance_supports_proposed &&
                        app.currentConfiguration.metadata.distance_supports_proposed == 'n/a') {
                        // No valid support (any distance)
                        errors.push(
                            self.translate("app_checkstate_no_valid_supports_invalid")
                        )
                    } else {
                        // no valid support, but distance
                        errors.push(
                            self.translate("app_checkstate_distance_between_supports_invalid")
                        )
                    }

                    // MAIL???


                } else {
                    errors.push(
                        element.message
                    )
                }
            });
        // Unex.warn(errors)
        return errors;

    }
    //function called every time main componnets are mounted
    //com en el router ja hi ha el beforeEnter no cal crear la funcio checkStageOrRedirect
    //o passarli un parameere pq redirigeixi, perque en el callbackKO ja es passa una funcio
    //que fara el next a una pantalla endarrera

    /**
     * Comprova si el stage que es passa com a paràmetre és correcte
     *
     * @param {*} stage
     * @param {*} showErrors
     * @param {*} callbackOK
     * @param {*} callbackKO
     */
    checkStage(stage, callbackValid, callbackInvalid) {
        var self = this;

        //-------------------------------------------------------------
        // comproba configuracio actual passada es valida a servidor, donat un stage
        //-------------------------------------------------------------
        //el API.process actualitza el currentconfiguration amb el del servidor
        //i executa els callbacks passats valid, invalid, error de conexio, spinner
        self.API.checkStage(
            stage,

            // Stage Valid
            function () {

                self.saveCurrentConfigurationToSessionStorage();
                callbackValid();

            },

            // Stage Invalid
            function () {

                self.saveCurrentConfigurationToSessionStorage();
                callbackInvalid();

            }
        )
    }

    async asyncProcess(b_showSpinner = false,
        b_validate_CurrentConfiguration = false,
        b_donthidespinner = false,
        newStage = 0
    ) {

        var self = this;

        if (this.currentConfiguration.stage == 3) {
            // Capture main element image:
            // await this.getScreenshotMainElement()
        }

        let result = await self.API.asyncProcess(

            //callbackValid
            () => {
                self.updateCurrencyFormat();
                // self.saveCurrentConfigurationToSessionStorage();
            },

            //callbackInvalid
            async (error) => {
                await self.showConfigurationErrors();
            },

            //callbackOnConnectionError
            () => false,

            //validateCurrentConfiguration
            b_validate_CurrentConfiguration,

            //showSpinner
            b_showSpinner,

            b_donthidespinner);


        // stage=4 show errors as Toasts
        if (b_validate_CurrentConfiguration == false &&
            this.currentConfiguration.stage == 4) {
            // let errors = this.getConfigurationErrors();
            // errors.forEach(err => {
            //     this.showToast(err, null, true)
            // });
        }
        return result;
    }

    // routerPush(name, props) {

    async routerPush(name) {

        if (this.router !== null && this.router !== undefined) {
            try {
                await this.routerPushAsync(name.toString())
            } catch (error) {
                // Unex.error(error, "Configurator.Routing");
            }
        } else {
            Unex.error("Trying to push without router", "Configurator.Routing");
        }
    }
    async routerPushAsync(route) {
        let self = this;
        return new Promise((resolve, reject) => {
            self.router.push(route, resolve, reject);
            window.scrollTo(0, 0);
        });
    }
    updateCurrencyFormat() {
        // aplica currency format
        var AppComponent = this.AppComponent;
        AppComponent.$CurrencyFilter.setConfig({
            symbol: this.currentConfiguration.priceList.currency,
            thousandsSeparator: this.currentConfiguration.priceList.thousands_separator,
            fractionCount: 2,
            fractionSeparator: this.currentConfiguration.priceList.decimal_separator,
            symbolPosition: (this.currentConfiguration.priceList.currency_position == "right" ? "" : "front"),
            symbolSpacing: true
        })
    }

    translate(string) {
        return i18n.t(string);
    }

    /**
     * Tracks stage change Analytics Events
     * @param {*} stage
     * @param {*} variant
     */
    trackGoal(stage, variant) {
        switch (stage) {
            case 1:
                this.trackEvent('1_select_configurator')
                break;
            case 2:
                this.trackEvent('2_select_family')
                break;
            case 3:
                this.trackEvent('3_main_elements')
                break;
            case 4:
                this.trackEvent('4_results')
                break;

            default:
                break;
        }
    }
    /**
     * Tracks a generic Analytics Event
     * @param {*} eventName
     * @param {*} eventValue
     */
    trackEvent(eventName, eventValue) {
        if (!this.analytics) return;

        this.analytics.logEvent(
            eventName,
        )
    }

    trackError(errorMessage, fatal = false) {
        if (!this.analytics) return;

        this.analytics.logEvent(
            "exception",
            {
                description: errorMessage,
                fatal: fatal
            }
        )
    }
    trackParameterSelection(attribute_type, attribute_id) {
        if (!this.analytics) return;

        this.analytics.logEvent(
            "select_content",
            {
                content_type: attribute_type,
                content_id: attribute_id
            })
    }
    trackScreenView(viewName) {
        if (!this.analytics) return;

        this.analytics.logEvent("screen_view", {
            screen_name: viewName,
            app_version: this.version
        });
    }
    /**
     * Captures a PNG from a DOM element
     * @param {*} element
     * @returns
     */
    async screenshot(element) {
        try {
            let dataUrl = await htmlToImage.toJpeg(
                element,
                {
                    width: 800,
                    // height: 600,
                    pixelRatio: 1,
                    backgroundColor: 'White'
                })

            return dataUrl;
        } catch (error) {
            Unex.error("Error screenshoting element", "Configurador")
        }
        try {
            let width = $(element).width();
            let height = $(element).height();
            let scrollY = $(element).position().top;
            // console.warn(element)
            var canvas = await html2canvas(element,
                {
                    scale: 1,
                    // width: 1024,
                    // height: 768,
                    // windowWidth: 1024,
                    // windowHeight: 768,
                    y: scrollY,
                    removeContainer: false
                });
            var png = canvas.toDataURL()

            return png;

        } catch (error) {
            console.warn('error html2canvas: ', error);
        }
    }

    async getScreenshotMainElement() {
        let mainElement = $('#main-elements');
        // console.warn(mainElement);
        if (mainElement.length > 0) {

            try {
                let mainElementsImage =
                    await this.screenshot(mainElement[0]);

                this.currentConfiguration.mainElementsImage = mainElementsImage;

                return true;

            } catch (error) {
                Unex.error("Error capturing main element image", "Configurator");
                return false;
            }
        }
    }

    async showToast(body = null, title = null, error = false, autohide = true) {
        if (!title) {
            title = this.translate('toast_title');
        }

        // WRAPPER:
        if (this.toastWrapper == null) {
            // d-flex justify-content-center
            this.toastWrapper = $(
                "<div class='' " +
                "   style='position: fixed; z-index:2000; bottom: 10px; right: 10px;'>" +
                "</div>"
            )
            $("body").append(this.toastWrapper)

        }

        let html =
            "       <div class='toast clearfix' role='alert' style='z-index:2000;' >" +
            "           <div class='toast-header " +
            "               " + (error ? 'bg-danger text-white' : 'bg-success text-white') + "'" +
            "               >" +
            "               <strong class='mr-auto'>" + title + "</strong>" +
            "               <button type='button' class='ml-2 mb-1 close text-white' data-dismiss='toast'>" +
            "                   <span>&times;</span>" +
            "               </button>" +
            "           </div>" +
            "           <div class='toast-body " +
            "               " + (error ? 'alert-danger' : 'alert-success') + "'" +
            "               >" +
            "               " + body +
            "           </div>" +
            "       </div>" +
            "</div>"

        let element = $(html)
        $(this.toastWrapper).append(element)
        $(element).toast({
            autohide: autohide,
            delay: 3500
        });
        $(element).toast('show');

        $(element).on('hidden.bs.toast', function () {
            $(element).remove()
        });
    }

    /**
     * Returns mainElement image from selected value or first enabled value
     */
    getImage(mainElement, parameter) {
        let parameterValue = mainElement[parameter].value
        if (parameterValue)
            return parameterValue.image

        let parameterValues = mainElement[parameter].values

        for (const value of parameterValues) {
            if (value.status) {
                return value.image;
            }
        }
    }

    isMobile() {
        return window.innerWidth < 650;
    }

    /**
     * Neteja tots els valors dels paràmetres de P2
     */
    async cleanP2Parameters() {
        // Loop through familyParameters values resetting all selected values in currentConfiguration.familyParameters
        let self = this
        let famParams = this.currentConfiguration.familyParameters;

        Object.values(famParams).map((item) => {
            if (item.value.constructor.name == "Array") {
                // self.$set(item, "value", []);
                item.value = "";
            } else {
                item.value = "";
            }
        });

        await this.asyncProcess(true);
    }

    /**
     * Neteja tots els valors dels paràmetres de P3
     */
    async cleanP3Parameters() {
        var self = this;

        this.showSpinner();

        this.currentConfiguration.mainElementParameters = [];

        // Delete value commonMainElementParameters
        let commonMainParams = this.currentConfiguration.commonMainElementParameters;

        Object.values(commonMainParams).map((commonMainParam) => {
            if (commonMainParam.value.constructor.name == "Array") {
                commonMainParam.value = [];
            } else {
                commonMainParam.value = "";
            }
        });

        // Multinivell
        this.multiLevelHelper.rows = 1

        await this.asyncProcess(false);

        this.hideSpinner();

    }
}


export const app = new application();
export const appConfigurator = app;
